const BlockNewsletter = () => {
  let $component

  const self = {
    init () {
      $component = document.querySelector('.BlockNewsletter')
      if (!$component) return
      self.addEventListeners()
    },
    onLoad () {
      const $input = $component.querySelector('.apsispro-signup-email')
      if ($input) $input.placeholder = 'Din e-postadress'
    },
    addEventListeners () {
      self.onLoad()
    }
  }

  return self
}

export default BlockNewsletter
